import { graphql, useStaticQuery } from "gatsby";

export default function useRestaurantDetails(restaurantId) {
	const { allRestaurants } = useStaticQuery(graphql`
		query {
			allRestaurants: allMarkdownRemark(
				filter: { frontmatter: { show: { eq: true } } }
			) {
				...AllRestaurants
			}
		}
	`);

	allRestaurants.nodes.forEach((restaurant) => {
		const hours = restaurant.frontmatter.hours;
		if (
			!Array.isArray(hours) ||
			hours.length !== 7 ||
			!hours.every(
				(day) =>
					Array.isArray(day) &&
					day.every(
						(slot) =>
							Array.isArray(slot) &&
							slot.length === 2 &&
							typeof slot[0] === "string" &&
							typeof slot[1] === "string" &&
							/^\d{2}:\d{2}$/.test(slot[0]) &&
							/^\d{2}:\d{2}$/.test(slot[1])
					)
			)
		) {
			throw new Error(
				`Invalid hours format for restaurant with id: ${restaurant.fields.id}`
			);
		}
	});

	return allRestaurants.nodes.find(
		(restaurant) => restaurant.fields.id === restaurantId
	);
}
